/**
 * Created by wwei on 2018-11-09.
 */

import React, { Component } from "react";
import { translate, Interpolate } from "react-i18next";
import { Form, Input, Button, Upload, Icon, Switch } from "antd";
import { Alert } from "react-bootstrap";

import { httpRequest as request } from "../../../common/functions/CustomRequest.js";
import writeLog from "../../../common/functions/LogUtil.js";
import getUrl from "../../../common/functions/CommonUtils.js";
import Constants from "../../../common/Constants.js";
import NotificationManager from "../../../common/components/CustomNotificationManager.js";
import DeleteModal from "../../../common/components/DeleteModal.js";
import Settings from "../../../common/Settings";

const FormItem = Form.Item;

class AmazonAccountForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      a4bEnabled: false, // the switch value
      hasStoredCredential: false, // whether there is a stored setting
      data: {
        arn: "",
        externalId: ""
      },

      switching: false, // switch operation in progress
      saving: false, // saving in progress
      testing: false,

      testPassed: false,
      showDelModal: false,
      fileList: []
    };
  }

  componentDidMount() {
    const { t } = this.props;
    this.getCredentials().catch(err => {
      if (err.status !== 404) {
        console.error("Failed to get a4b credentials. ", err);
        NotificationManager.error(t("A4B.GET_FAILED"));
      }
    });
  }

  getCredentials = () => {
    const url = getUrl(Constants.a4b, true, true, "/credentials");
    return request(url, "get", {}).then(res => {
      const setting = res.body;
      this.setState({
        hasStoredCredential: true,
        a4bEnabled: setting.enabled,
        data: {
          arn: setting.arn,
          externalId: setting.externalId
        }
      });
    });
  };

  saveConfig = () => {
    const { t } = this.props;
    this.props.form.validateFields((err, data) => {
      if (!err) {
        this.setState({ saving: true });
        const url = getUrl(Constants.a4b, true, true, "/credentials");
        request(url, "post", data)
          .then(() => {
            writeLog("save", "amazon_account", "Save Amazon account.");
            this.setState({ data, saving: false, hasStoredCredential: true });
            NotificationManager.success(t("A4B.SAVE_DONE"));
          })
          .catch(err => {
            writeLog(
              "fail-save",
              "amazon_account",
              "Failed to save Amazon account."
            );
            this.setState({ saving: false });
            console.error("Failed to save a4b credentials. ", err);
            NotificationManager.error(t("A4B.SAVE_FAILED"));
          });
      }
    });
  };

  test = () => {
    const { t } = this.props;
    this.props.form.validateFields((err, data) => {
      if (!err) {
        this.setState({ testing: true });
        const url = getUrl(Constants.a4b, true, true, "/credentials/verify");
        request(url, "post", data)
          .then(() => {
            writeLog("test", "amazon_account", "Test Amazon account.");
            this.setState({ testing: false, testPassed: true });
            NotificationManager.success(t("A4B.TEST_DONE"));
          })
          .catch(err => {
            writeLog(
              "fail-test",
              "amazon_account",
              "Failed to test Amazon account."
            );
            this.setState({ testing: false, testPassed: false });
            console.error("Failed to test a4b credentials. ", err);
            NotificationManager.error(t("A4B.TEXT_FAILED"));
          });
      }
    });
  };

  uploadChange = info => {
    const { t } = this.props;
    let fileList = info.fileList;
    fileList = fileList.slice(-1); // only allow 1 file uploaded

    fileList = fileList.filter(file => {
      if (file.response) {
        this.props.form.resetFields();
        if (file.status === "done") {
          this.setState({ data: file.response, testPassed: false });
          return true;
        } else if (file.status === "error") {
          NotificationManager.error(t("DEVICE.FAIL_UPLOAD"));
          this.uploadRemove();
          return false;
        }
      }
      return true;
    });

    this.setState({ fileList });
  };

  uploadRemove = () => {
    if (!this.state.hasStoredCredential) {
      this.props.form.resetFields();
      this.setState({
        data: { arn: "", externalId: "" },
        testPassed: false
      });
    }
  };

  toggleSwitch = checked => {
    if (!this.state.hasStoredCredential) {
      this.setState({ a4bEnabled: checked });
      if (!checked) {
        this.setState({
          data: { arn: "", externalId: "" },
          fileList: []
        });
      }
      return;
    }
    const { t } = this.props;
    this.setState({ switching: true });
    const url = getUrl(
      Constants.a4b,
      true,
      true,
      checked ? "/enable" : "/disable"
    );
    request(url, "post", {})
      .then(() => {
        writeLog(
          "Edit",
          "amazon_account",
          checked ? "Enable A4B." : "Disable A4B."
        );
        this.setState({ a4bEnabled: checked, switching: false });
      })
      .catch(err => {
        writeLog(
          "Edit",
          "amazon_account",
          checked ? "Failed to enable A4B." : "Failed to disable A4B."
        );
        this.setState({ switching: false });
        console.error("Failed to enable/disable a4b. ", err);
        NotificationManager.error(
          checked ? t("A4B.ENABLE_FAILED") : t("A4B.DISABLE_FAILED")
        );
      });
  };

  deleteCredential = () => {
    const { t } = this.props;
    const url = getUrl(Constants.a4b, true, true, "/credentials");
    return request(url, "delete", {})
      .then(() => {
        this.setState({
          hasStoredCredential: false,
          showDelModal: false,
          testPassed: false,
          data: {
            arn: "",
            externalId: ""
          }
        });
        NotificationManager.success(t("A4B.DELETE_SUCCESS"));
        writeLog("Delete", "amazon_account", "Delete account setting.");
      })
      .catch(err => {
        writeLog(
          "Delete",
          "amazon_account",
          "Failed to delete account setting."
        );
        this.setState({ showDelModal: false });
        console.error("Failed to delete account. ", err);
        NotificationManager.error(t("A4B.DELETE_FAILED"));
      });
  };

  render() {
    const { t } = this.props;
    const {
      saving,
      data,
      testing,
      testPassed,
      a4bEnabled,
      switching,
      showDelModal,
      hasStoredCredential,
      fileList
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { sm: { span: 7 } },
      wrapperCol: { sm: { span: 17 } }
    };

    const uploadProps = {
      name: "foo",
      action: "/api/upload/amazon",
      accept: ".csv",
      onChange: this.uploadChange,
      onRemove: this.uploadRemove,
      withCredentials: true,
      disabled: !a4bEnabled || hasStoredCredential
    };

    return (
      <div className="page-container">
        <div id="container" className="col-md-12 listView">
          <h2 className="page-title">{t("A4B.AMAZON_ACCOUNT")}</h2>
          <div>
            {t("A4B.ALLOW_DESC")}
            <span style={{ marginLeft: 20 }}>
              <Switch
                onChange={this.toggleSwitch}
                checked={a4bEnabled}
                loading={switching}
                checkedChildren={t("COMMON.TRUE")}
                unCheckedChildren={t("COMMON.FALSE")}
              />
            </span>
          </div>
          <div style={{ marginTop: 15 }}>{t("A4B.INSTRUCTION")}</div>
          <hr />
          <div style={{ margin: "20px 0" }}>
            <Interpolate
              i18nKey="A4B.ACCOUNT_DESC"
              useDangerouslySetInnerHTML={true}
              link={
                <a
                  href={Settings.A4B_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t("A4B.AMAZON_LINK")}
                </a>
              }
            />
          </div>
          <div style={{ width: "50%" }}>
            <Upload {...uploadProps} fileList={fileList}>
              <Button disabled={!a4bEnabled || hasStoredCredential}>
                <Icon type="upload" /> {t("A4B.UPLOAD")}
              </Button>
            </Upload>
          </div>
          <div className="amazon-account">
            <Form>
              <FormItem {...formItemLayout} label={t("A4B.ARN")}>
                {getFieldDecorator("arn", {
                  initialValue: data.arn,
                  rules: [
                    { required: true, message: t("COMMON.FIELD_REQUIRED") }
                  ]
                })(
                  <Input
                    autoFocus
                    onChange={() => this.setState({ testPassed: false })}
                    disabled={!a4bEnabled}
                    readOnly={hasStoredCredential}
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label={t("A4B.EXTERNAL_ID")}>
                {getFieldDecorator("externalId", {
                  initialValue: data.externalId,
                  rules: [
                    { required: true, message: t("COMMON.FIELD_REQUIRED") }
                  ]
                })(
                  <Input
                    onChange={() => this.setState({ testPassed: false })}
                    disabled={!a4bEnabled}
                    readOnly={hasStoredCredential}
                  />
                )}
              </FormItem>
              <div style={{ width: "170%" }}>
                <Alert bsStyle="info">{t("A4B.TIP")}</Alert>
              </div>
              <div
                className="ant-modal-footer"
                style={{ paddingLeft: 0, paddingRight: 0 }}
              >
                <div
                  className="col-lg-8"
                  style={{ textAlign: "left", padding: 0 }}
                >
                  {!hasStoredCredential && (
                    <Button
                      size="large"
                      type="primary"
                      onClick={this.saveConfig}
                      id="amazonSaveBtn"
                      loading={saving}
                      disabled={testing || !testPassed}
                    >
                      {saving ? t("COMMON.SAVING") : t("COMMON.SAVE")}
                    </Button>
                  )}
                  {!hasStoredCredential && (
                    <Button
                      size="large"
                      onClick={this.test}
                      id="amazonTestBtn"
                      loading={testing}
                      disabled={!a4bEnabled || testPassed}
                    >
                      {t("A4B.TEST")}
                    </Button>
                  )}
                </div>
                <div
                  className="col-lg-4"
                  style={{ padding: 0, float: "right" }}
                >
                  {hasStoredCredential && (
                    <Button
                      type="danger"
                      size="large"
                      onClick={() => this.setState({ showDelModal: true })}
                      disabled={a4bEnabled || switching}
                    >
                      {t("COMMON.DELETE")}
                    </Button>
                  )}
                </div>
              </div>
            </Form>
          </div>
        </div>
        <DeleteModal
          show={showDelModal}
          delFunc={this.deleteCredential}
          title={t("A4B.DELETE_TITLE")}
          context={t("A4B.DELETE_SURE")}
          onClose={() => this.setState({ showDelModal: false })}
        />
      </div>
    );
  }
}

const AmazonAccount = Form.create()(AmazonAccountForm);
export default translate()(AmazonAccount);



// WEBPACK FOOTER //
// ./src/tenantportal/a4b/amazonAccount/AmazonAccount.js